import script from "./Pla01ViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./Pla01ViewPage.vue?vue&type=script&setup=true&lang=js"

import "./Pla01ViewPage.vue?vue&type=style&index=0&id=5e95537e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e95537e"]])

export default __exports__